import { GRAY, SKY } from 'styles/Colors';
import { isFunction } from 'lodash';
import { Link as RouterLink } from 'react-router-dom';

import DivButton from 'components/controls/DivButton';
import React from 'react';

export const linkStyle = {
  color: SKY,
  textAlign: 'center',
  textDecoration: 'underline'
};

const disabledStyle = {
  color: GRAY,
  cursor: 'not-allowed',

  svg: {
    fill: GRAY
  }
};

function Link({
  to,
  disabled,
  children,
  navigate,
  id,
  style = {},
  heapCallback
}) {
  return (
    <>
      {navigate && (
        <DivButton
          id={id}
          handleClick={() => {
            if (disabled) return;
            if (isFunction(heapCallback)) {
              heapCallback(id);
            }
            navigate(to);
          }}
          style={[linkStyle, style, disabled ? disabledStyle : null]}
        >
          {children}
        </DivButton>
      )}
      {!navigate && (
        <RouterLink to={to} style={linkStyle}>
          {children}
        </RouterLink>
      )}
    </>
  );
}

export default Link;
